<template>
  <div>
    <h1>Stock In Transit</h1>
    <hr>

    <!-- FILTER STARTS -->
    <flexibleFilter
      :date_filter="false"
      :fetch_filter="fetchFilter"
      @onFilter="setFilterUrl"
    ></flexibleFilter>
    <!-- FILTER ENDS -->

    <!-- Main Dealer Only Start -->
    <div v-if="isMainDealer">
      <stock-in-transit-stats
        :filterUrl="filterUrl"
        :api_url="'/api/h1/stock-intransit/ahm-to-md'"
        :title="'AHM to MD'"
        :reverse="false"
        :type="'MAINDEALER'"
        :stats_color="'#348FE2'"
      ></stock-in-transit-stats>
    </div>
    <!-- Main Dealer Only End -->

    <div v-else>
      <stock-in-transit-stats
        :filterUrl="filterUrl"
        :api_url="'/api/h1/stock-intransit/md-to-karesidenan'"
        :title="'MD to Karesidenan'"
        :reverse="false"
        :type="'DEALER'"
        :stats_color="'#348FE2'"
      ></stock-in-transit-stats>

      <stock-in-transit-stats
        :filterUrl="filterUrl"
        :api_url="'/api/h1/stock-intransit/md-to-city'"
        :title="'MD to City'"
        :reverse="true"
        :type="'DEALER'"
        :stats_color="'rgb(73,182,214)'"
      ></stock-in-transit-stats>

      <div class="row mt-5">
        <div class="outerBox col-md-6">
          <div class="innerBox">
            <stock-in-transit-table
              :filterUrl="filterUrl"
              :api_url="'/api/h1/stock-intransit/table-dealer'"
              :title="'All Stock In Transit To Dealer'"
            ></stock-in-transit-table>
          </div>
        </div>
        <div class="outerBox col-md-6">
          <div class="innerBox">
            <stock-in-transit-table
              :filterUrl="filterUrl"
              :api_url="'/api/h1/stock-intransit/table-city'"
              :title="'All Stock In Transit To City'"
            ></stock-in-transit-table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import qs from 'qs'
  import flexibleFilter from '@/components/filter/flexible_filter.vue'

  import stockInTransitStats from './children/stockInTransitStats'
  import stockInTransitTable from './children/stockInTransitTable'

  export default {
    data () {
      return {
        filterUrl : '',
        fetchFilter : 0,
        isMainDealer : true,
      }
    },
    components : {
      flexibleFilter,
      stockInTransitStats,
      stockInTransitTable,
    },
    mounted () {
      this.fetchFilter++;
    },
    watch : {
      filterUrl(){
        this.isMainDealer = qs.parse(this.filterUrl).locationType == 'MAINDEALER' ? true : false
      }
    },
    methods : {
      setFilterUrl(a){
        this.filterUrl = a
      }
    }
  }
</script>

<style scoped>
  
</style>